import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import customer from '../customer'
import project from '../project'
import actions from './actions'

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions,
  modules: {
    customer,
    project
  }
}
